import { ServiceCenter } from '@/modules/insurers/serviceCenters/types/ServiceCenter.ts'
import { appConfig } from '@/config/app.ts'

export interface ServiceCenterState {
  isLoading: boolean
  serviceCenters: ServiceCenter[]
  isCreateModalOpen: boolean
  editId: string | null
  filters: string
}

export const initialState: ServiceCenterState = {
  isLoading: false,
  serviceCenters: [],
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
